import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EmployeesFormContractsForm } from '@modules/employees/EmployeesFormContractsForm';
import { contractsGridColumns } from '@modules/employees/_employeesColumns';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Pracovní úvazky</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="contracts"
            Form={EmployeesFormContractsForm}
            columns={contractsGridColumns}
            showCheckboxes={true}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormContracts = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormContracts.tsx